import { Controller } from 'cerebral';
import Devtools from 'cerebral/devtools';
import Useragent from '@cerebral/useragent';

import Router from './router';
import App from './modules/app';
import providers from './providers';

const controller = Controller({
    providers: [
        function Context(context) {
            context.api = providers.api; // eslint-disable-line
            return context;
        },
    ],
    devtools:
        process.env.NODE_ENV === 'production'
            ? null
            : Devtools({ host: 'localhost:39005' }),
    modules: {
        router: Router,
        app: App,
        useragent: Useragent({
            media: {
                small: '(max-width: 576px)',
                medium: '(max-width: 768px)',
            },
        }),
    },
});

export default controller;



// WEBPACK FOOTER //
// ./src/store/controller.js